import { render, staticRenderFns } from "./TechStackSection.vue?vue&type=template&id=18f7c9b5&scoped=true"
import script from "./TechStackSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TechStackSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7c9b5",
  null
  
)

export default component.exports